module.exports = __webpack_public_path__ + "static/media/remove-widget-icon.a1392b4b.svg";